const state = {
  currentTableSearch: null,
  currentTablePage: null,
  currentTablePerPage: null,
  currentTableStateFilter: null,
  previous: {
    search: null,
    page: null,
    perPage: null,
    state: null,
  },
};

const getters = {};

const actions = {
  setCurrentTablePage(context, value) {
    context.commit('SET_CURRENT_TABLE_PAGE', value);
  },

  setCurrentTablePerPage(context, value) {
    context.commit('SET_CURRENT_TABLE_PER_PAGE', value);
  },

  setCurrentTableSearch(context, value) {
    context.commit('SET_CURRENT_TABLE_SEARCH', value);
  },

  setCurrentTableStateFilter(context, value) {
    context.commit('SET_CURRENT_TABLE_STATE_FILTER', value);
  },

  saveTableCurrentFilters(context) {
    // guardar estado actual en previo
    context.dispatch('setPreviousTableFilters');
    // borrar estado actual
    context.dispatch('setCurrentTableFilters', true);
  },

  retrieveTablePreviousFilters(context) {
    // recuperar estado previo
    context.dispatch('setCurrentTableFilters');
    // borrar estado previo
    context.dispatch('setPreviousTableFilters', true);
  },

  setCurrentTableFilters(context, clear = false) {
    context.commit('SET_CURRENT_TABLE_FILTERS', {
      search: clear ? null : context.state.previous.search,
      page: clear ? null : context.state.previous.page,
      perPage: clear ? null : context.state.previous.perPage,
      stateFilter: clear ? null : context.state.previous.state,
    });
  },

  setPreviousTableFilters(context, clear = false) {
    context.commit('SET_PREVIOUS_TABLE_FILTERS', {
      search: clear ? null : context.state.currentTableSearch,
      page: clear ? null : context.state.currentTablePage,
      perPage: clear ? null : context.state.currentTablePerPage,
      stateFilter: clear ? null : context.state.currentTableStateFilter,
    });
  },

  cleanCurrentTableSearch(context) {
    context.commit('SET_CURRENT_TABLE_SEARCH', null);
  },
};

const mutations = {
  SET_CURRENT_TABLE_PAGE(state, value) {
    state.currentTablePage = value;
  },

  SET_CURRENT_TABLE_PER_PAGE(state, value) {
    state.currentTablePerPage = value;
  },

  SET_CURRENT_TABLE_SEARCH(state, value) {
    state.currentTableSearch = value;
  },

  SET_CURRENT_TABLE_STATE_FILTER(state, value) {
    state.currentTableStateFilter = value;
  },

  SET_CURRENT_TABLE_FILTERS(state, { search, page, perPage, stateFilter }) {
    state.currentTableSearch = search;
    state.currentTablePage = page;
    state.currentTablePerPage = perPage;
    state.currentTableStateFilter = stateFilter;
  },

  SET_PREVIOUS_TABLE_FILTERS(state, { search, page, perPage, stateFilter }) {
    state.previous.search = search;
    state.previous.page = page;
    state.previous.perPage = perPage;
    state.previous.state = stateFilter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
